import GuestActions from '../../../actions/GuestActions';

import UserStore from '../../../stores/UserStore';

import NotificationActions from '../../../actions/NotificationActions';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';

import PageHeader from '../../form/layout/PageHeader.react';
import PageRow from '../../form/layout/PageRow.react';
import Input from '../../form/input/Input.react';
import InputDOB from '../../form/input/InputDOB.react';

class ViewStorefrontAccess extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false,
            username : this.props.guest.UserName || this.props.guest.Email,
            password : '',
        };

        this.accessStoreFront = this.accessStoreFront.bind(this);
    }

    accessStoreFront() {
        var self = this;

        if (this.state.loading)
            return;

        if (this.state.password.length === 0 || this.state.username.length === 0) {
            NotificationActions.alert('Add username and password');
            return;
        }

        this.setState({ loading : true }, () => {

            AjaxPromises.POST(GuestEndPoints.ACCESS_STOREFRONT, UserStore.getApiData({
                GuestId : self.props.guest.Guest_id,
                OnlineStatus : 'Active',
                OnlinePassword : self.state.password,
                OnlineEmailLogin : self.state.username,
            })).then(res => {
                if (res.Result && res.Data && res.Data[0].IDStatus === 'Completed') {
                    NotificationActions.success('User account created successfully!');
                    GuestActions.loadFullGuest(self.props.guest.Guest_id);
                } else {
                    self.setState({ loading : false }, () => {
                        if(res.Data.length > 0 && res.Data[0].IDStatus) {
                            NotificationActions.error(res.Data[0].IDStatus);
                        } else {
                            NotificationActions.error('Something went wrong!');
                        }
                    });
                }
            });
        });
    }

    render() {
        var hasAccess = this.props.guest.UserName ? true : false;

        return ([
                <PageHeader title={'Storefront access '+(hasAccess ? '' : ' - Create customer account')} />,

                <PageRow title='Username'>
                    <Input tabindex='15'
                        value={hasAccess ? this.props.guest.UserName : this.state.username}
                        onChange={username => { this.setState({ username }); }}
                        disabled={hasAccess || this.props.guest.IsAnonymous}
                        placeholder='Username' />
                </PageRow>,

                <PageRow title='Password'>
                    <Input tabindex='16'
                        type='password'
                        disabled={this.props.guest.IsAnonymous}
                        value={this.state.password}
                        onChange={password => { this.setState({ password }); }}
                        placeholder='Password'
                        id='StorefrontPass'
                        action={{
                            icon : 'eye',
                            onClick : () => {
                                var passwordField = document.getElementById('StorefrontPass');
                                var value = passwordField.value;

                                if(passwordField.type == 'password') {
                                    passwordField.type = 'text';
                                }
                                else {
                                    passwordField.type = 'password';
                                }

                                passwordField.value = value;
                            }
                        }} />
                </PageRow>,

                !this.props.guest.IsAnonymous &&
                <PageRow title=''>
                    <div tabindex='17'
                        className='btn-green'
                        onClick={this.accessStoreFront}>

                        { !hasAccess ? 'Allow Access' : 'Reset Password' }
                    </div>
                </PageRow>,
        ]);
    }
}

export default ViewStorefrontAccess;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ViewStorefrontAccess.react.jsx